module.exports = __webpack_public_path__ + "img/button_off.1c6b204d.png";